<template>
  <section class="pdf-page-container">
    <slot></slot>
    <div class="html2pdf__page-break" v-if="currentPage < totalPages"></div>
  </section>
</template>

<script>
export default {
  name: "pdf-page-container",
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
  },
  components: {},
};
</script>

<style lang="less" scope>
  @pageWidth: 1120px;
  @pageHeight: 794px;

  .pdf-page-container {
    position: relative;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: @pageWidth;
    height: @pageHeight;
    margin: 0 auto;
    box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.3);
    background-color: @pure-white;

    > section {
      padding-left: 30px;
      padding-right: 30px;

      &:first-of-type {
        padding-top: 50px;
      }

      &:last-of-type {
        padding-bottom: 50px;
      }
    }
  }
</style>
